/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: patched for B4A-7073 (IsKit / ProductKit).
 */

export interface ProductKitComponent {
  productVariantId?: number;
  quantity?: number;
  productVariantName?: string;
  millenniumSKU?: string;
  internalEAN?: string;
}
